import createAttachmentsApi from './provider';

const EVENTS_ATTACHMENT_TYPE_ID = 2;

const { get, add, edit, remove } = createAttachmentsApi(EVENTS_ATTACHMENT_TYPE_ID);
export { get, add, edit, remove };